import React from 'react';
import { FaBuilding } from 'react-icons/fa';
import './AboutHero.css';

const AboutHero = () => {
    return (
        <section className="_aHSec_o1A_">
            <div className="_aHCont_p2B_">
                <div className="_hIWrap_q3C_">
                    <FaBuilding className="_hIcon_r4D_" />
                </div>
                <h1 className="_hTitle_s5E_">About Vanidya</h1>
                <p className="_hSubtitle_t6F_">
                    Vanidya is a curated marketplace for Satvik groceries, organic foods, pooja essentials and spiritual books. Our mission is to make mindful, culturally rooted living simple for customers, sellers and communities across India.
                </p>
            </div>
        </section>
    );
};

export default AboutHero;